import {Cureus} from '../Cureus';

Cureus.CommentForm = {};

//= require_tree ./CommentForm